<template>
   <HeaderDash />
   <SideMenu /> 
   <ContentEditProject /> 
</template>
<script>
// Importando los componententes pertenecientes a esta vista
import HeaderDash from '@/components/team/dashboard/HeaderDash.vue'
import SideMenu from '@/components/team/dashboard/SideMenu.vue'
import ContentEditProject from '@/components/team/dashboard/modules/project/ContentEditProject.vue'

export default 
{
  name: 'EditProject',
  components: 
  {
    HeaderDash,
    SideMenu,
    ContentEditProject
  }
}
</script>
<style>

</style>
